<script>
export default {
  name: 'PieIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#8E8E8E',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.67 6.9499C21.03 4.7799 19.22 2.9699 17.05 2.3299C15.4 1.8499 14.26 1.8899 13.47 2.4799C12.52 3.1899 12.41 4.4699 12.41 5.3799V7.8699C12.41 10.3299 13.53 11.5799 15.73 11.5799H18.6C19.5 11.5799 20.79 11.4699 21.5 10.5199C22.11 9.7399 22.16 8.5999 21.67 6.9499Z"
      :fill="color"
    />
    <path
      d="M18.91 13.3599C18.65 13.0599 18.27 12.8899 17.88 12.8899H14.3C12.54 12.8899 11.11 11.4599 11.11 9.69991V6.11991C11.11 5.72991 10.94 5.34991 10.64 5.08991C10.35 4.82991 9.95002 4.70991 9.57002 4.75991C7.22002 5.05991 5.06002 6.34991 3.65002 8.28991C2.23002 10.2399 1.71002 12.6199 2.16002 14.9999C2.81002 18.4399 5.56002 21.1899 9.01002 21.8399C9.56002 21.9499 10.11 21.9999 10.66 21.9999C12.47 21.9999 14.22 21.4399 15.71 20.3499C17.65 18.9399 18.94 16.7799 19.24 14.4299C19.29 14.0399 19.17 13.6499 18.91 13.3599Z"
      :fill="color"
    />
  </svg>
</template>
